import LoginView from '@/views/Auth/LoginView/LoginView.vue'
import InviteRegisterView from '@/views/Auth/InviteRegisterView/InviteRegisterView.vue'
import ExistingUserRegistrationView from '@/views/Auth/ExistingUserRegistrationView/ExistingUserRegistrationView.vue'

export default [
  {
    path: '/login',
    component: LoginView,
    name: 'Login',
    meta: { publicRoute: true }
  },
  {
    path: '/partner-invite/:id/:token',
    component: ExistingUserRegistrationView,
    name: 'existingUserRegistrationView',
    meta: { publicRoute: true }
  },
  {
    path: '/partner-signup/:id/:token',
    component: InviteRegisterView,
    name: 'InviteRegister',
    meta: { publicRoute: true }
  }
]
